import {
    axiosInst,
  } from "../credentials.js";
  import { get } from 'svelte/store';
  import { userDetails } from "../ui-store.js";
  import { formatMimeType } from "../utils/helpers.js";
  import { uploadFileIntoProcess } from "./newUserRequestService.js";
  import moment from "moment";

  export const fileUploadToUserProfile = async (fileList, filedata) => {
    console.log(fileList, filedata);
    let formData = new FormData();
    if (filedata && fileList && fileList.length) {
        console.log("inside formdata")
      formData.append("file", fileList[0]);
      formData.append("alias", filedata.fileTitle);
      formData.append("registeredOrganizationId ", filedata.registeredOrganizationId);
    }

    for (var key of formData.entries()) {
        console.log(key[0] + ', ' + key[1]);
    }
    return uploadFileIntoProcess(formData).then((uploadedFile) => {
        // let momentObj = moment(e.detail[0][0], 'DD/MM/YYYY');
        let now = moment();
        let userdoc = {
            fileTitle: filedata.fileTitle,
            fileDescription: filedata.fileDescription,
            versionedFileId: uploadedFile.versionedFileId,
            uploadDate: now.format('YYYY-MM-DD HH:mm:ss'),
            sizeInBytes: uploadedFile.currentVersion.length,
            mimeType: uploadedFile.currentVersion.mimeType
        };

        console.log(userdoc);

        return addDocumentToUser(userdoc, filedata.userTaxId).then((updatedUser) => {
            return updatedUser;
        });
    });
  };

  const addDocumentToUser = async (document, userTaxId) => {
    return new Promise(async (resolve, reject) => {
      try {
        let url = "externalEntities/addDocument?userTaxId="+userTaxId;
        const res = await get(axiosInst).post(url, document);
        if (res.status === 200) {
          console.log("addDocumentToUser successful call", res.data.data);
          resolve(res.data.data);
        } else {
          alert("addDocumentToUser :: something went wrong", res);
          reject();
        }
      } catch (e) {
        console.log(e);
        reject(e);
      }
    });
  };

  export const updateUserInfo = async (userTaxId) => {
    //transform user details store to hashmap
    // let userInfoMap = get(userDetails).map(detail -> { return {detail.id, detail}})
    let userInfoMap = Object.fromEntries(
      get(userDetails).map(e => [e.id, e])
    );
    return new Promise(async (resolve, reject) => {
      try {
        let url = "externalEntities/updateInfo?userTaxId="+userTaxId;
        const res = await get(axiosInst).post(url, userInfoMap);
        if (res.status === 200) {
          console.log("updateUserInfo successful call", res.data.data);
          resolve(res.data.data);
        } else {
          alert("updateUserInfo :: something went wrong", res);
          reject();
        }
      } catch (e) {
        console.log(e);
        reject(e);
      }
    });
  };

  //download a document from open1Process
  const getURL = (document, orgId, issuerQuintuplet) => {
    return new Promise(async (resolve, reject) => {
      await get(axiosInst)
        .get("open1process/files/" + document.versionedFileId, {
          params: {
            registeredOrganizationId: orgId,
            issuerQuintuplet,
          },
        })
        .then(function (response) {
          if (response.status !== 200) {
            console.log(
              "Looks like there was a problem. Status Code: " + response.status
            );
            reject();
          } else {
            console.log(response.data.data.currentVersion.url);
            console.log(response.data.data);
            let urltemp = response.data.data.currentVersion.url;
            if (process.env.BASE_URL.indexOf("https://") !== -1) {
              // this is a secure connection, convert the url to https:
              urltemp = urltemp.replace("http://", "https://");
            }
            let result = {
              docId: document.versionedFileId,
              versionFileId: response.data.data.currentVersion.fileId,
            };
            resolve(result);
          }
        })
        .catch(function (err) {
          console.log("Fetch Error :-S", err);
          reject(err);
        });
    });
  };

  const createDownloadLink = (orgId, docId, versionFileId) => {
    //response needs to be an arraybuffer, in order to build the blob url
    let fileType;
    return new Promise(async (resolve, reject) => {
      try {
        const res = await get(axiosInst)
          .get(
            "open1process/files/" +
              docId +
              "/version/" +
              versionFileId +
              "/content",
            {
              params: { registeredOrganizationId: orgId },
            },
            {
              responseType: "arraybuffer",
              transformRequest: (data, headers) => {
                delete headers["SessionID"];
                return data;
              },
            }
          )
          .then(function (response) {
            // console.log(response.status);
            if (response.status === 200) {
              console.log("successful download");
              var arr = response.data.data.content;
              var byteArray = Uint8Array.from(atob(arr), (c) =>
                c.charCodeAt(0)
              );
              var blob = new Blob([byteArray], {
                type: response.data.data.contentType,
              });
              let mimeType = formatMimeType(response.data.data.contentType);
              let downloadLink = URL.createObjectURL(blob, {
                type: response.data.data.contentType,
              });
              let result = {
                downloadLink: downloadLink,
                type: null,
              };
              //if mimetype is of certain type, add property to file (we need it for a download bug)
              if (
                mimeType === "DOC" ||
                mimeType === "DOCX" ||
                mimeType === "ODT"
              )
                result.type = mimeType.toLowerCase();
              resolve(result);
            } else {
              reject("something went wrong");
            }
          });
      } catch (e) {
        console.log(e);
        reject(e);
      }
    });
  };

  export const downloadFileFromProcess = (doc, orgId, issuerQuintuplet) => {
    console.log(doc);
    getURL(doc, orgId, issuerQuintuplet).then((res) => {
      createDownloadLink(orgId, res.docId, res.versionFileId).then((result) => {
        var a = document.createElement("a");
        a.href = result.downloadLink;
        //if result.type has been set, add extension to filename (for download  bug)
        a.setAttribute(
          "download",
          result.type ? doc.fileTitle + "." + result.type : doc.fileTitle
        );
        a.click();
      });
    });
  };

  export const removeDocumentFromUser = (userId, documentId) => {
    return new Promise(async (resolve, reject) => {
      try {
        let url = "externalEntities/" + userId + "/documents/delete/" + documentId;
        const res = await get(axiosInst).delete(url);
        if (res.status === 200) {
          console.log("removeDocumentFromUser successful call", res.data.data);
          resolve(res.data.data);
        } else {
          // alert("removeDocumentFromUser :: something went wrong", res);
          reject("removeDocumentFromUser :: something went wrong");
        }
      } catch (e) {
        console.log(e);
        reject(e);
      }
    });
  }

  